document.addEventListener('DOMContentLoaded', () => {

  // this function
  function pauseOtherWaveSurfers(currentWaveSurfer) {
      document.querySelectorAll('.audio-plyr').forEach(function(el) {
        var wavesurfer = el.wavesurferInstance;
        if (wavesurfer !== currentWaveSurfer) {
          wavesurfer.pause();
        }
      });
    }


    document.querySelectorAll('.audio-plyr').forEach(function(el) {
        var audio = el.getAttribute('data-audio')

        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        let context, processor;
        const ctx = document.createElement('canvas').getContext('2d');
    
        if (isSafari) {
          const AudioContext = window.AudioContext || window.webkitAudioContext;
          context = new AudioContext();
          processor = context.createScriptProcessor(1024, 1, 1);
        }

        var wavesurfer = WaveSurfer.create({
            container: el.querySelector('.waveform'),
            waveColor: 'rgba(183, 183, 183, 1.000)',
            cursorColor: 'transparent',
            progressColor: '#fff',
            normalize: true,
            height: 27,
            hideScrollbar: true,
            audioContext: context || null,
            audioScriptProcessor: processor || null
        });

        wavesurfer.load(audio); 

        el.wavesurferInstance = wavesurfer; // this one

        var playPause = el.querySelector('.play-btn');
        playPause.addEventListener('click', function () {
            pauseOtherWaveSurfers(wavesurfer); // this one
            wavesurfer.playPause();
        });

        wavesurfer.on('play', function () {
            el.querySelector('.playicon').style.display = 'none';
            el.querySelector('.pauseicon').style.display = '';
        });

        wavesurfer.on('pause', function () {
            el.querySelector('.pauseicon').style.display = 'none';
            el.querySelector('.playicon').style.display = '';
        });
    });

        var atc_btn = document.querySelector('.atc-button')
        var atc_sec = document.querySelector('.variant-adds') || document.querySelector('.variant-adds-courses')

        if ( atc_btn !== null && atc_sec !== null ) {
            atc_btn.addEventListener('click', function () {
                atc_sec.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
            });
        }


    var linkToggle = document.querySelectorAll('.js-toggle');

    for(i = 0; i < linkToggle.length; i++) {
        linkToggle[i].addEventListener('click', function(event) {

        event.preventDefault();

        var container = document.getElementById(this.dataset.container);

        if (!container.classList.contains('active')) {
            this.classList.add('is-open');
            container.classList.add('active');
            container.style.height = 'auto';

            var height = container.clientHeight + 'px';

            container.style.height = '0px';

            setTimeout(function () {
                container.style.height = height;
            }, 0);
        
        } else {
            this.classList.remove('is-open');
        
            container.style.height = '0px';

            container.addEventListener('transitionend', function () {
            container.classList.remove('active');
        }, {
            once: true
        });
        
        }
        
    });
    }
});


// // Bind controls
// document.addEventListener('DOMContentLoaded', function () {
//     var playPause = document.querySelector('#playPause');
//     playPause.addEventListener('click', function () {
//         wavesurfer.playPause();
//     });

//     // Toggle play/pause text
//     wavesurfer.on('play', function () {
//         document.querySelector('#play').style.display = 'none';
//         document.querySelector('#pause').style.display = '';
//     });
//     wavesurfer.on('pause', function () {
//         document.querySelector('#play').style.display = '';
//         document.querySelector('#pause').style.display = 'none';
//     });
    
//     wavesurfer.on('ready', function () {
//       var timeline = Object.create(WaveSurfer.Timeline);

//       timeline.init({
//         wavesurfer: wavesurfer,
//         container: '#waveform-timeline'
//       });
//     });
  
//     wavesurfer.on('audioprocess', function() {
//       $('.time-readout').html(parseFloat(wavesurfer.getCurrentTime()).toFixed(2));
// });